// extracted by mini-css-extract-plugin
export default {"loginBut":"index_loginBut__QMHvB"};